import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
 
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  height: "100%",
  justifyContent: "center",
 
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

function ImageUploadBox(props: any) {
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = props?.dropZoneProps;

  const style: any = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div className="container" style={{  maxWidth: "192px",
    width: "100%", height: "192px", cursor: "pointer", borderRadius: "8px" }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <AddPhotoAlternateIcon fontSize="large" sx={{pl: "10px", pr: "10px", mb: -2}}/>
        <p style={{padding: 10, fontSize: "16px"}}>Drag and drop a file here, or click to select files</p>
      </div>
    </div>
  );
}

export default ImageUploadBox;
